'use strict';

var assign = require('../constant/assign.js');

function shallow(object) {
  return assign({}, object);
}

module.exports = shallow;